import { itensTextosAtendimento, resultadoTextosValido, respostaAtendimentoValida } from "./prontuario-save";

const clone = value => JSON.parse(JSON.stringify(value));
const contexto = vm => JSON.stringify([vm.$route.fullPath, vm.idPaciente, vm.idAgenda, vm.idAtendimento]);
const textosPendentes = textos => textos.map(exame => ({ ...exame, TEXTOS: (exame.TEXTOS || []).filter(texto => !texto.SALVO_DIRETAMENTE) }));
export function copiarTextosAtendimento(textos, encode) {
  const copia = clone(textosPendentes(textos));
  for(const exame of copia) {
    if(!exame.TEXTOS.length) { delete exame.LIBERAR_LAUDO; delete exame.GERAR_PDF; }
    for(const texto of exame.TEXTOS || []) { texto.CONTEUDO = encode(texto.CONTEUDO || ""); }
  }
  return copia;
}

const semIDsComplementos = rows => (rows || []).map(item => {
  const copia = { ...item }; delete copia.ID_ATENDIMENTO_HISTORICO; delete copia.ID_AGENDA_RETORNO; delete copia.ID_ATENDIMENTOS_CID; delete copia.ID_PACIENTE_IMAGEM; delete copia.tokenConfirmado; return copia;
});
export function assinaturaEdicao(vm) {
  const textos = clone(vm.textosIncluindo);
  for(const exame of textos) { for(const texto of exame.TEXTOS || []) { delete texto.ID_DIVERSOS; } }
  return JSON.stringify([textos, vm.$refs.atendimentoInclusao?.retornaFichaDados(), semIDsComplementos(vm.cidIncluindo),
    semIDsComplementos(vm.imagensIncluindo), semIDsComplementos(vm.agendasRetornoIncluindo), semIDsComplementos(vm.historicosIncluindo), (vm.solicitacoesProcedimentosIncluindo || []).map(item => {
      const copia = { ...item }; delete copia.ID; return copia;
    }), vm.infoTissIncluindo]);
}

const controles = new WeakMap();
export function textosAtendimento(vm) {
  if(controles.has(vm)) { return controles.get(vm); }
  let req, ocupada = false, encerrado = false;
  const vigente = item => !encerrado && req === item && contexto(vm) === item.contexto;
  const mostrar = (mensagem, concluir = false) => {
    vm.gravacaoPendenteMensagem = mensagem;
    vm.textosAtendimentoEstado = { pendente: true, ocupada, concluir, itens: vm.textosAtendimentoEstado.itens || [] };
  };
  function aplicar(item, resposta) {
    if(!vigente(item) || !resultadoTextosValido(resposta, item.payload)) { return false; }
    const estados = [];
    for(const resultado of resposta.textos) {
      const original = item.fontes.find(fonte => fonte.chave === resultado.CHAVE);
      const atualExame = vm.textosIncluindo.find(exame => String(exame.ID_AGENDA_EXAME) === String(original.exame.ID_AGENDA_EXAME) && String(exame.ID_PRODUTO) === String(original.exame.ID_PRODUTO));
      const atual = atualExame?.TEXTOS?.find(texto => texto === original.ref || (original.texto.ID != null && texto.ID === original.texto.ID));
      if(atual && resultado.ESTADO === "CONFIRMADO") { atual.ID_DIVERSOS = resultado.ID_DIVERSOS; }
      estados.push({ chave: resultado.CHAVE, titulo: original.texto.TITULO || "Texto", id: resultado.ID_DIVERSOS,
        confirmado: resultado.ESTADO === "CONFIRMADO", avisos: resultado.AVISOS || [] });
    }
    for(const resultado of resposta.solicitacoes || []) {
      const fonte = item.solicitacoes[Number(resultado.CHAVE)];
      const atual = vm.solicitacoesProcedimentosIncluindo.find(s => s === fonte.ref || (fonte.copia.ID_LOCAL && s.ID_LOCAL === fonte.copia.ID_LOCAL) || (fonte.copia.ID && s.ID === fonte.copia.ID));
      if(atual && resultado.ESTADO === "CONFIRMADO") { atual.ID = resultado.ID_SOLICITACAO_EXAME; }
      estados.push({ chave: "solicitacao:" + resultado.CHAVE, titulo: fonte.copia.DESCRICAO || "Solicitação",
        id: resultado.ID_SOLICITACAO_EXAME, confirmado: resultado.ESTADO === "CONFIRMADO", avisos: [] });
    }
    for(const [lista, fonteLista, campo, titulo] of [["historicos", "historicosIncluindo", "ID_ATENDIMENTO_HISTORICO", "Histórico"], ["retornos", "agendasRetornoIncluindo", "ID_AGENDA_RETORNO", "Retorno"]]) {
      for(const resultado of (item.payload.CONFIRMAR_HISTORICOS_RETORNOS ? resposta[lista] : []) || []) {
        const fonte = item[lista][Number(resultado.CHAVE)];
        const atual = (vm[fonteLista] || []).find(s => s === fonte.ref || (fonte.copia.ID_LOCAL && s.ID_LOCAL === fonte.copia.ID_LOCAL));
        if(atual && resultado.ESTADO === "CONFIRMADO") { atual[campo] = resultado[campo]; }
        estados.push({ chave: lista + ":" + resultado.CHAVE, titulo: fonte.copia.DESCRICAO || fonte.copia.MOTIVO || titulo,
          id: resultado[campo], confirmado: resultado.ESTADO === "CONFIRMADO", avisos: [] });
      }
    }
    for(const resultado of (item.payload.CONFIRMAR_CIDS_ATENDIMENTO ? resposta.cids : []) || []) {
      const fonte = item.cids[Number(resultado.CHAVE)];
      for(const atual of vm.cidIncluindo || []) {
        if(String(atual.ID_CID) === String(fonte.copia.ID_CID) && resultado.ESTADO_CID === "CONFIRMADO") {
          atual.ID_ATENDIMENTOS_CID = resultado.ID_ATENDIMENTOS_CID;
        }
      }
      estados.push({ chave: "cid:" + resultado.CHAVE, titulo: "CID " + fonte.copia.CID,
        id: resultado.ID_ATENDIMENTOS_CID, confirmado: resultado.ESTADO === "CONFIRMADO",
        avisos: resultado.ESTADO_CID === "CONFIRMADO" && resultado.ESTADO_AREA === "INDETERMINADO" ? ["CID confirmado; vínculo com a área ainda pendente."] : [] });
    }
    for(const resultado of (item.payload.CONFIRMAR_ANEXOS_ATENDIMENTO ? resposta.anexos : []) || []) {
      const fonte = item.anexos[Number(resultado.CHAVE)];
      const atual = (vm.imagensIncluindo || []).find(anexo => anexo === fonte.ref || (fonte.copia.id != null && anexo.id === fonte.copia.id));
      if(atual && resultado.ESTADO_REGISTRO === "CONFIRMADO") {
        atual.ID_PACIENTE_IMAGEM = resultado.ID_PACIENTE_IMAGEM;
        atual.tokenConfirmado = resultado.ARQUIVO_TOKEN;
      }
      const etapas = [];
      if(resultado.ESTADO_REGISTRO !== "CONFIRMADO") { etapas.push("registro"); }
      if(resultado.ESTADO_ARQUIVO !== "CONFIRMADO") { etapas.push("arquivo"); }
      if(resultado.ESTADO_ORIGEM === "INDETERMINADO") { etapas.push("associação de origem"); }
      estados.push({ chave: "anexo:" + resultado.CHAVE, titulo: fonte.copia.titulo || fonte.copia.nome || "Anexo",
        id: resultado.ID_PACIENTE_IMAGEM, confirmado: resultado.ESTADO === "CONFIRMADO",
        avisos: etapas.length ? ["Pendente: " + etapas.join(", ") + ".", ...(resultado.AVISOS || [])] : [] });
    }
    if(item.payload.CONFIRMAR_PRINCIPAL_ATENDIMENTO) {
      const principal = resposta.principal;
      estados.push({ chave: "cabecalho", titulo: "Dados gerais e TISS", confirmado: principal.ESTADO_CABECALHO === "CONFIRMADO", avisos: [] });
      for(const ficha of principal.fichas) {
        estados.push({ chave: "ficha:" + ficha.CHAVE, titulo: item.payload.DETALHES[Number(ficha.CHAVE)].TPC || "Ficha clínica",
          id: ficha.ID_ATENDIMENTO_DETALHE, confirmado: ficha.ESTADO === "CONFIRMADO", avisos: [] });
      }
      estados.push({ chave: "remocoes-fichas", titulo: "Conferência das fichas removidas", confirmado: principal.ESTADO_REMOCOES === "CONFIRMADO", avisos: [] });
    }
    vm.textosAtendimentoEstado.itens = estados;
    item.resposta = resposta;
    const completo = respostaAtendimentoValida(resposta, item.payload);
    const preservado = assinaturaEdicao(vm) === item.assinatura;
    mostrar(completo ? (preservado ? "Gravação confirmada. Você pode concluir a ação sem reenviar o atendimento." :
      "A gravação foi confirmada, mas há alterações posteriores na tela. Elas foram preservadas; confira antes de sair.") :
      "Há etapas sem confirmação. Os dados foram preservados; consulte o resultado ou clique em Salvar para retomar a tentativa.", completo && preservado);
    return completo && preservado;
  }
  async function salvar(payload, opcoes, horaInicio) {
    if(req || ocupada || encerrado) { return false; }
    const fontes = itensTextosAtendimento({ TEXTOS: textosPendentes(vm.textosIncluindo) }).map(item => ({ ...item, ref: item.texto, texto: clone(item.texto) }));
    const item = { payload: clone(payload), fontes, solicitacoes: (vm.solicitacoesProcedimentosIncluindo || []).map(s => ({ ref: s, copia: clone(s) })), contexto: contexto(vm), assinatura: assinaturaEdicao(vm), opcoes: clone(opcoes), horaInicio };
    item.historicos = (vm.historicosIncluindo || []).map(s => ({ ref: s, copia: clone(s) }));
    item.retornos = (vm.agendasRetornoIncluindo || []).map(s => ({ ref: s, copia: clone(s) }));
    item.cids = (vm.cidIncluindo || []).map(s => ({ ref: s, copia: clone(s) }));
    item.anexos = (vm.imagensIncluindo || []).map(s => ({ ref: s, copia: clone(s) }));
    req = item; ocupada = true;
    vm.autoSaveSuspenso = true;
    mostrar("Salvando e confirmando os itens do atendimento…");
    try {
      try { await vm.guardarOperacaoProntuario?.("gravacao", { payload: item.payload, opcoes: item.opcoes, horaInicio, assinatura: item.assinatura }); }
      catch(error) { limpar(); throw new Error(error.message || "Não foi possível preservar a tentativa. Nenhuma gravação foi enviada."); }
      if(!vigente(item)) { return false; }
      let resposta;
      try { resposta = await vm.salvarAtendimento(item.payload); }
      catch(error) { resposta = error.resposta; }
      if(!vigente(item)) { return false; }
      if(resposta?.queued) {
        mostrar(resposta.message || "Atendimento guardado no dispositivo, aguardando sincronização.");
        return false;
      }
      if(!resultadoTextosValido(resposta, item.payload)) {
        try { resposta = await vm.consultarTextosAtendimento(item.payload); } catch(error) { /* Mantém solicitação original. */ }
      }
      if(!vigente(item)) { return false; }
      if(aplicar(item, resposta)) {
        const avisos = vm.textosAtendimentoEstado.itens.flatMap(texto => texto.avisos);
        if(avisos.length) { await vm.$swal({ icon: "warning", title: "Gravação confirmada", text: avisos.join(" ") }); }
        if(!vigente(item)) { return false; }
        if(assinaturaEdicao(vm) !== item.assinatura) {
          mostrar("Há alterações posteriores à gravação. O conteúdo foi preservado; confira antes de sair."); return false;
        }
        limpar();
        return true;
      }
      if(!resultadoTextosValido(resposta, item.payload)) { mostrar("Não foi possível confirmar a gravação. Os dados foram preservados; consulte o resultado ou clique em Salvar para tentar novamente."); }
      return false;
    } finally {
      ocupada = false;
      if(vigente(item)) { vm.textosAtendimentoEstado.ocupada = false; }
    }
  }
  async function consultar() {
    const item = req;
    if(!item || ocupada || !vigente(item)) { return false; }
    ocupada = true; vm.textosAtendimentoEstado.ocupada = true;
    try {
      const resposta = await vm.consultarTextosAtendimento(item.payload);
      if(!vigente(item)) { return false; }
      if(!resultadoTextosValido(resposta, item.payload)) {
        mostrar("A confirmação ainda não está disponível. Nenhuma gravação foi reenviada."); return false;
      }
      return aplicar(item, resposta);
    } catch(error) {
      if(vigente(item)) { mostrar("Consulta indisponível. Os dados permanecem preservados."); }
      return false;
    } finally { ocupada = false; if(vigente(item)) { vm.textosAtendimentoEstado.ocupada = false; } }
  }
  async function retomar(opcoes) {
    const item = req;
    if(!item || ocupada || !vigente(item)) { return false; }
    ocupada = true;
    mostrar("Conferindo e retomando o salvamento do atendimento…");
    try {
      let resposta = await vm.consultarTextosAtendimento(item.payload);
      if(!vigente(item)) { return false; }
      if(!respostaAtendimentoValida(resposta, item.payload)) {
        resposta = await vm.retomarSalvamentoAtendimento(item.payload);
        if(!vigente(item)) { return false; }
      }
      aplicar(item, resposta);
      if(!respostaAtendimentoValida(resposta, item.payload)) {
        mostrar(resposta?.mensagem || "A tentativa ainda não foi confirmada. Corrija a causa e clique em Salvar para tentar novamente.");
        return false;
      }
      if(assinaturaEdicao(vm) !== item.assinatura) {
        // A operação antiga foi confirmada. A edição atual segue aberta e será salva
        // por uma nova operação, com os IDs confirmados já incorporados à tela.
        await vm.terminarOperacaoProntuario?.(item.payload.ID_CLIENT_REQUEST);
        if(!vigente(item)) { return false; }
        limpar();
        return { novaGravacao: true };
      }
      item.opcoes = { ...item.opcoes, ...opcoes };
      vm.prontuarioClientRequestId = item.payload.ID_CLIENT_REQUEST;
    } catch(error) {
      if(vigente(item)) { mostrar(error.message || "Não foi possível retomar. Os dados foram preservados; tente salvar novamente."); }
      return false;
    } finally {
      ocupada = false;
      if(vigente(item)) { vm.textosAtendimentoEstado.ocupada = false; }
    }
    return concluir();
  }
  function restaurar(dados, assinatura) {
    if(req || ocupada || encerrado || !dados?.payload || String(dados.payload.ID_PACIENTE) !== String(vm.idPaciente) ||
      String(dados.payload.ID_ATENDIMENTO) !== String(vm.idAtendimento)) { return false; }
    const payload = clone(dados.payload);
    req = { payload, opcoes: clone(dados.opcoes || {}), horaInicio: dados.horaInicio, contexto: contexto(vm), assinatura,
      fontes: itensTextosAtendimento(payload).map(item => ({ ...item, texto: clone(item.texto) })),
      solicitacoes: (payload.SOLICITACOES || []).map(copia => ({ copia })),
      historicos: (payload.HISTORICOS || []).map(copia => ({ copia })), retornos: (payload.RETORNOS || []).map(copia => ({ copia })),
      cids: (payload.CID || []).map(copia => ({ copia })), anexos: (payload.IMAGENS || []).map(copia => ({ copia })) };
    vm.autoSaveSuspenso = true;
    mostrar("Retomando a tentativa de salvamento preservada neste dispositivo…");
    return true;
  }
  function limpar() {
    req = null;
    vm.textosAtendimentoEstado = { pendente: false, ocupada: false, concluir: false, itens: [] };
    vm.autoSaveSuspenso = false;
    vm.gravacaoPendenteMensagem = "";
  }
  async function concluir() {
    const item = req;
    if(!item || ocupada || !vigente(item) || !respostaAtendimentoValida(item.resposta, item.payload)) { return false; }
    if(assinaturaEdicao(vm) !== item.assinatura) { mostrar("Há alterações posteriores à gravação. O conteúdo foi preservado; confira antes de sair."); return false; }
    const avisos = vm.textosAtendimentoEstado.itens.flatMap(texto => texto.avisos);
    ocupada = true; vm.textosAtendimentoEstado.ocupada = true;
    try {
      if(avisos.length) { await vm.$swal({ icon: "warning", title: "Gravação confirmada", text: avisos.join(" ") }); }
      if(!vigente(item)) { return false; }
      if(assinaturaEdicao(vm) !== item.assinatura) { mostrar("Há alterações posteriores à gravação. O conteúdo foi preservado; confira antes de sair."); return false; }
      limpar();
    } finally {
      ocupada = false;
      if(vigente(item)) { vm.textosAtendimentoEstado.ocupada = false; }
    }
    if(item.opcoes.somenteAnexos) { await vm.concluirAnexosSalvos(); }
    else { return await vm.concluirAtendimentoSalvo(item.opcoes, item.horaInicio) !== false; }
    return true;
  }
  const controller = { salvar, consultar, retomar, restaurar, concluir, pendente: () => !!req, destruir: () => { encerrado = true; } };
  controles.set(vm, controller);
  return controller;
}
